import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/home/SectionLabel";
import { SERVICES } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

export function ServicesSection() {
    return (
        <section id="services" className="max-w-[1240px] mx-auto px-6 lg:px-10 py-16">
            <Reveal>
                <SectionLabel className="text-terracotta">What we handle</SectionLabel>
                <h2 className="font-heading text-4xl sm:text-5xl tracking-tight text-ink mt-4 max-w-2xl">
                    Six services that keep your revenue cycle moving.
                </h2>
            </Reveal>

            <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 border-t border-l border-linec">
                {SERVICES.map((s, i) => {
                    const Icon = s.icon;
                    return (
                        <Reveal key={s.title} delay={(i % 3) * 0.08}>
                            <div className="group relative border-r border-b border-linec p-8 lg:p-10 h-full transition-colors duration-300 hover:bg-stone2/60 overflow-hidden">
                                <span className="absolute top-0 left-0 h-0.5 w-0 bg-terracotta transition-all duration-500 group-hover:w-full" />
                                <div className="flex items-start justify-between">
                                    <span className="w-12 h-12 rounded-sm bg-sage/5 border border-linec flex items-center justify-center transition-colors duration-300 group-hover:bg-sage">
                                        <Icon
                                            size={22}
                                            className="text-sage transition-colors duration-300 group-hover:text-cream"
                                            strokeWidth={1.6}
                                        />
                                    </span>
                                    <ArrowUpRight
                                        size={20}
                                        className="text-linec opacity-0 -translate-x-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0 group-hover:text-terracotta"
                                    />
                                </div>
                                <h3 className="font-heading text-2xl text-ink mt-6">{s.title}</h3>
                                <p className="text-sm text-inksoft leading-relaxed mt-3">{s.blurb}</p>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </section>
    );
}
